// Hash helpers for Outreach list/detail and Slack deep-links.
// Query string lives in the fragment (`#outreach?priority=null&reason=launched`)
// so it must be stripped before treating the path as a page or doctor id.

export function parseOutreachHash(hash = "") {
  const raw = String(hash).replace(/^#/, "");
  const qIndex = raw.indexOf("?");
  const path = qIndex === -1 ? raw : raw.slice(0, qIndex);
  const query = qIndex === -1 ? "" : raw.slice(qIndex + 1);
  const parts = path.split("/").filter(Boolean);
  const params = new URLSearchParams(query);

  const doctorUserId = parts[0] === "outreach" && parts[1] ? parts[1] : null;
  const priorityTokens = String(params.get("priority") || "")
    .split(",")
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);
  const archivedOnly = priorityTokens.includes("null");
  const reason = String(params.get("reason") || "").trim().toLowerCase();

  return {
    doctorUserId,
    archivedOnly,
    archiveReason: reason === "launched" ? "launched" : null,
  };
}
